function cookiesPopup(){
  
  var urlParams = new URLSearchParams(window.location.search); //get all parameters
var check_country = urlParams.get('country'); //extract the country parameter - this will return NULL if country isn't a parameter

     // Check country 
  if(check_country){
    var check_country_rg="true";
    Cookies.set('cookieaccept_popup', '2', { expires: 5 }); // cookie will expire in five days
         
  }
  else{
   var check_country_rg="false";
 
  }
   
  
    // Check cookie 
  if (Cookies.get('cookieaccept_popup') != "2" && check_country_rg == "false" ) {
     window.location.hash = "#popup1";    
  }
    //Assign cookie on click
    $('.UK_region').on('click',function(){
         Cookies.set('cookieaccept_popup', '2', { expires: 1 }) // cookie will expire in ten days
         
   	$('#popup1').css("opacity", "0").fadeOut(500);
    });
 	 $('.close').on('click',function(){
       
       $('#popup1').css("opacity", "0").fadeOut(500);
       
      });
};


window.onload = function() {
  
    // trigger cookie policy bar
    cookiesPopup();

}




